module.exports = __webpack_public_path__ + "img/10-villas.6bed38ec.jpg";